import { Dispatch } from "redux";
import {
    UserFormAction,
    changeRoleAction,
    clearInputFormAction,
    initUserListAction,
    inputFormEmailAction,
    inputFormPasswordAction,
    inputFormRepeatPasswordAction,
    inputFormTruckAction,
    inputFormUsernameAction,
    selectedEditUserAction,
    selectedUserStatusAction,
} from "./action";
import { Role, Status } from "../userRoleList/state";
import { userDataList } from "./state";

export function inputFormUsernameThunk(username: string) {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(inputFormUsernameAction(username));
    };
}

export function inputFormPasswordThunk(password: string) {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(inputFormPasswordAction(password));
    };
}

export function inputFormRepeatPasswordThunk(repeatPassword: string) {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(inputFormRepeatPasswordAction(repeatPassword));
    };
}

export function changeRoleThunk(role: Role) {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(changeRoleAction(role));
    };
}

export function inputFormEmailThunk(email: string) {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(inputFormEmailAction(email));
    };
}

export function inputFormTruckThunk(truck: string) {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(inputFormTruckAction(truck));
    };
}

export function clearInputThunk() {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(clearInputFormAction());
    };
}

export function initUserListThunk(userList: userDataList[]) {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(initUserListAction(userList));
    };
}

export function selectedEditUserThunk(userInfo: userDataList) {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(selectedEditUserAction(userInfo));
    };
}

export function selectedUserStatusThunk(status: Status) {
    return (dispatch: Dispatch<UserFormAction>) => {
        dispatch(selectedUserStatusAction(status));
    };
}
